import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import * as countries from 'i18n-iso-countries';
import * as en from 'i18n-iso-countries/langs/en.json';
countries.registerLocale(en);


@Injectable()
export class CountryRestrictionService {
  private isAllowed: Promise<boolean>;

  showCountryRestrictionBlock: boolean = false;
  userCountry: string = '';

  constructor(private http: Http) {

  }

  checkIfUserAllowed() {

    if (this.isAllowed === undefined) {
      this.isAllowed = this.http.get('/api/country-restrictions/restricted-countries')
        .toPromise()
        .then(resp => {

          const userCountryCode = resp.headers.get('CF-IPCountry') || 'XX';
          const restrictedCountries = resp.json().restrictedCountries as string[];
          const shouldEnter = restrictedCountries.filter(item => (item !== 'US' && item !== 'GB'))
            .includes(userCountryCode) === false;

          this.showCountryRestrictionBlock = !shouldEnter;
          this.userCountry = countries.getName(userCountryCode, 'en');

          return shouldEnter;
        })
        .catch(() => true);
    }

    return this.isAllowed;
  }

  public allowUser(): void {
    this.isAllowed = Promise.resolve(true);
    this.showCountryRestrictionBlock = false;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/country-restriction/country-restriction.service.ts